// Default game length in minutes, keyed by sport. Sport is single-sourced from
// organization.sports[0] (see CLAUDE.md). Only sports that differ from the
// baseline need an entry here.
// Canonical home: configDefaults.ts (ADR 0035); this module stays as the
// established import path.
import { defaultGameDurationInMinutes } from './configDefaults';

export default function getDefaultGameDuration(sport?: string | null): number {
  return defaultGameDurationInMinutes(sport);
}
